export default {
    THOUSAND: "тыс.",
    MILLION: "млн.",
    BILLION: "млрд.",
    TRILLION: "трлн."
};
